Vendd.Scripts.load(function () {

    var $boxes = $('.x-product-box-gtl-related');

    if ($boxes.length < 1)
        return;

    var $allToCartCont = $('.x-all-to-cart'), totalPrice = 0, numOfSelected = 0;

    $.each($boxes, function (i, box) {

        var $wrapper = $(box);

        if ($wrapper.length < 1)
            return;

        var wrapper = $wrapper.get(0);

        if ($('.product-json-generator', $wrapper).length < 1)
            return;

        var skuJsonHtml = $('.product-json-generator', $wrapper).html();     
        skuJsonHtml = skuJsonHtml.replace(/("[^"]*")|\s/g, "$1").replace(/,}/g, '}').replace(/,]/g, ']');

        var skuJson = JSON.parse(skuJsonHtml);

        $('.product-json-generator', $wrapper).remove();

        var selectedSku, selectedColor, selectedSize;

        var intRegex = /^[0-9]*$/, decRegex = /^[0-9]*(\.[0-9]+)$/;

        var $sizeSelector = $('.x-product-details-version-selector.sizelist', $wrapper);
        var $colorSelector = $('.x-product-details-version-selector.colorlist', $wrapper);
        var $quantitySelector = $('.x-product-details-quantity-selector', $wrapper);

        $.each($quantitySelector, function (i, control) {
            var $control = $(control);

            if ($control.data('type') == "incremental" ) {

                $control.on('click', '.js-minus', function (event) {

                    if ($control.hasClass('disabled'))
                        return;

                    var qty;
                    var quanta = $wrapper.data('quanta');
                    var minQty = $wrapper.data('min-quantity');

                    var $field = $('.js-selector', $control);

                    if (intRegex.test(quanta)) {
                        qty = parseInt($field.val()) - parseInt(quanta);
                    } else if (decRegex.test(quanta)) {
                        qty = parseFloat($field.val()) - parseFloat(quanta);
                        qty = qty.toFixed(2);
                    }

                    if (qty >= minQty) {
                        $field.val(qty);
                    }
                });

                $control.on('click', '.js-plus', function (event) {

                    if ($control.hasClass('disabled'))
                        return;

                    var qty;
                    var quanta = $wrapper.data('quanta');
                    var maxQty = $wrapper.data('max-quantity');

                    var $field = $('.js-selector', $control);

                    if (intRegex.test(quanta)) {
                        qty = parseInt($field.val()) + parseInt(quanta);
                    } else if (decRegex.test(quanta)) {
                        qty = parseFloat($field.val()) + parseFloat(quanta);
                        qty = qty.toFixed(2);
                    }

                    if ((maxQty && qty <= maxQty) || !maxQty) {
                        $field.val(qty);
                    }
                });
            }
        });

        $.each($('.x-product-details-version-selector', $wrapper), function (i, control) {
            var $control = $(control);

            if ($control.data('type') == "dropdown") {
                $control.on('change', '.js-selector', function (e) {

                    var $this = $(this);

                    var val = $this.val();

                    if ($control.hasClass("colorlist")) {

                        wrapper.updateSizes();

                        var sizelist = $('select', $sizeSelector);

                        if (val > 0)
                            sizelist.removeAttr('disabled');
                        else
                            sizelist.attr('disabled', 'true');
                    }

                    wrapper.updateProductInfo();

                    wrapper.updateQuantity();
                });
            }

            if ($control.data('type') == "list") {
                $control.on('click', '.js-selector', function (e) {

                    var $this = $(this);

                    if ($this.hasClass('disabled')) return;

                    var val = $this.val();

                    $('.js-selector', $control).removeClass('selected');

                    $this.addClass('selected');

                    if ($control.hasClass("colorlist")) {

                        wrapper.updateSizes();

                        var sizelist = $('ul', $sizeSelector);

                        if (val > 0)
                            sizelist.removeAttr('disabled');
                        else
                            sizelist.attr('disabled', 'true');
                    }
                    
                    wrapper.updateProductInfo();

                    wrapper.updateQuantity();
                });
            }            
        });

        $wrapper.on('click', '.js-add-to-cart', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this);

            if ($this.hasClass('disabled') || $this.is(':disabled'))
                return;

            if ($('.x-warehouse-selector-widget').trigger('addtocart').hasClass('opening'))
                return;

            var id = $wrapper.data("productid"),
                skuId = $wrapper.data("variantid"),
                path = $wrapper.data("path"),
                qty = $('.js-selector', $quantitySelector).val();

            var itemInfo = {
                minQuantity: $wrapper.data("min-quantity"),
                maxQuantity: $wrapper.data("max-quantity"),
                quanta: $wrapper.data("quanta")
            };

            //enhanced info
            var color = $wrapper.data("color");
            var size = $wrapper.data("size");
            var list = $('ul.related-list').data('list');

            var enhancedInfo = { color: color, size: size, list: list };
            //enhanced info

            if (qty < 1) return;

            Vendd.MessageBus.publishAsync($control.get(0), new Vendd.Cart.Messages.Add(id, skuId, path, qty, null, null, itemInfo, enhancedInfo));
            //Open the widget only for template 1 of Cart Widget
            if ($('.x-cart-widget').data('template') === 1) {
                Vendd.MessageBus.publishAsync($wrapper, new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.CartWidget, false));
            }
        });

        wrapper.updateColors = function () {
            var changeSelectedValue = false;

            var allColors = getSizes(skuJson,
                $sizeSelector.data('type') == "dropdown" ?
                    $('.js-selector', $sizeSelector).val() :
                    $('.js-selector.selected', $sizeSelector).val());

            $.each($('.option[data-set-value-id!=0]', $colorSelector), function () {
                var $option = $(this);
                var colorId = $option.data("set-value-id").toString();
                var isEnable = allColors.find(function (color) { return color === colorId; }) !== undefined;

                if (isEnable) {
                    $option.removeClass('disabled');
                } else {
                    if ($colorSelector.data('type') == "dropdown") {
                        if (colorId == $('.js-selector', $colorSelector).val()) {
                            changeSelectedValue = true;
                            $option.addClass('disabled');
                        }
                    } else {
                        if (colorId == $('.js-selector.selected', $colorSelector).val()) {
                            changeSelectedValue = true;
                            $option.addClass('disabled');
                        }
                    }
                }
            });

            if (changeSelectedValue) {
                $(".option", $colorSelector).attr('selected', null).removeClass('selected');
                $(".option:not(.disabled)", $colorSelector).first().attr('selected', 'selected').addClass('selected');

                if ($colorSelector.data('type') == "dropdown")
                    $colorSelector.val($(".option:not(.disabled)", $colorSelector).first().val());
            }
        }

        wrapper.updateSizes = function () {
            var changeSelectedValue = false;

            var allSizes = getSizes(skuJson,
                $colorSelector.data('type') == "dropdown" ?
                    $('.js-selector', $colorSelector).val() :
                    $('.js-selector.selected', $colorSelector).val());

            $.each($('.option[data-set-value-id!=0]', $sizeSelector), function () {
                var $option = $(this);
                var sizedId = $option.data("set-value-id").toString();
                var isEnable = allSizes.find(function (size) { return size === sizedId; }) != undefined;

                if (isEnable) {
                    $option.removeClass('disabled');
                } else {
                    if ($sizeSelector.data('type') == "dropdown") {
                        if (sizedId == $('.js-selector', $sizeSelector).val()) {
                            changeSelectedValue = true;
                            $option.addClass('disabled');
                        }
                    } else {
                        if (sizedId == $('.js-selector.selected', $sizeSelector).val()) {
                            changeSelectedValue = true;
                            $option.addClass('disabled');
                        }
                    }
                }
            });

            if (changeSelectedValue) {
                $(".option", $sizeSelector).attr('selected', null).removeClass('selected');
                $(".option:not(.disabled)", $sizeSelector).first().attr('selected', 'selected').addClass('selected');

                if ($sizeSelector.data('type') == "dropdown")
                    $sizeSelector.val($(".option:not(.disabled)", $sizeSelector).first().val());
            }
        }

        wrapper.updateProductInfo = function () {

            //get selected color
            selectedColor = $colorSelector.data('type') == "dropdown" ? $('.js-selector', $colorSelector) : $('.js-selector.selected', $colorSelector);
            //get selected size
            selectedSize = $sizeSelector.data('type') == "dropdown" ? $('.js-selector', $sizeSelector) : $('.js-selector.selected', $sizeSelector);
            //get selected sku
            selectedSku = getSKU(skuJson, selectedColor.val(), selectedSize.val());

            if (selectedColor.val() != "0") {
                var imgSrc = getImageColor(skuJson, selectedColor.val());
                if (imgSrc != null) $(' > .image-container img', $wrapper).attr("src", imgSrc);
            }

            if (selectedSku == undefined) {
                $('button.js-add-to-cart', $wrapper).addClass("disabled").attr("disabled", "disabled");
                if ($wrapper.hasClass('js-can-add-to-cart')) {
                    $wrapper.removeClass('js-can-add-to-cart');
                    numOfSelected -= 1;
                    if (numOfSelected <= 0) {
                        $('.js-add-all-to-cart', $allToCartCont).addClass("disabled").attr("disabled", "disabled");
                        $allToCartCont.addClass('none-selected');
                        totalPrice = 0;
                    } else {
                        totalPrice -= parseFloat(stringToNumber($wrapper.data('price')));
                    }
                }
                $('.js-num-of-selected', $allToCartCont).text(numOfSelected);
                $('.js-total-price', $allToCartCont).text(String(totalPrice.toFixed(2)).replace(".", ","));

                return;
            }

            //set selected sku
            $wrapper.data("variantid", selectedSku.SkuId);
            $wrapper.data("color", selectedColor.data("name"));
            $wrapper.data("size", selectedSize.data("name"));

            if (selectedSku.CanBuy.toLowerCase() == "true") {
                $('button.js-add-to-cart', $wrapper).removeClass("disabled").attr("disabled", null);
                if(!$wrapper.hasClass('js-can-add-to-cart')){
                    $wrapper.addClass('js-can-add-to-cart');
                    numOfSelected += 1;
                    totalPrice += parseFloat(stringToNumber($wrapper.data('price')));
                    $allToCartCont.removeClass('none-selected');
                    $('.js-add-all-to-cart', $allToCartCont).removeClass("disabled").attr("disabled", null);
                }
            } else {
                $('button.js-add-to-cart', $wrapper).addClass("disabled").attr("disabled", "disabled");
                if ($wrapper.hasClass('js-can-add-to-cart')) {
                    $wrapper.removeClass('js-can-add-to-cart');
                    numOfSelected -= 1;
                    if (numOfSelected <= 0) {
                        $('.js-add-all-to-cart', $allToCartCont).addClass("disabled").attr("disabled", "disabled");
                        $allToCartCont.addClass('none-selected');
                        totalPrice = 0;
                    } else {
                        totalPrice -= parseFloat(stringToNumber($wrapper.data('price')));
                    }
                }
            }

            $('.js-num-of-selected', $allToCartCont).text(numOfSelected);
            $('.js-total-price', $allToCartCont).text(String(totalPrice.toFixed(2)).replace(".", ","));

            //update price and availability
            var model = {};
            model.Price = {};
            model.Availability = {};
            model.Price.CurrentPrice = selectedSku.UnitPrice;
            model.Price.CurrentPriceText = selectedSku.UnitPriceText;
            model.Price.DeletedPrice = selectedSku.DeletedPrice != "" ? selectedSku.DeletedPrice : null;
            model.Price.DeletedPriceText = selectedSku.DeletedPrice != "" ? selectedSku.DeletedPriceText : null;
            model.Availability.AvailabilityActionId = selectedSku.AvailabilityActionId
            model.Availability.AvailabilityName = selectedSku.AvailabilityName

            var html = Vendd.Handlebars.parse("getTheLookPrices_A", model);

            $('.prices-container', $wrapper).html(html);
        }

        wrapper.updateQuantity = function () {
            if (selectedSku == undefined) {
                $quantitySelector.addClass('disabled');

                if ($quantitySelector.data('type') == "incremental") {
                    $quantitySelector.find('button').prop('disabled', true);
                    $quantitySelector.find('input').prop('disabled', true);
                } else {
                    $quantitySelector.find('select').prop('disabled', true);
                }
                
                return;
            }

            if (selectedSku.CanBuy.toLowerCase() == "true") {

                var model = {}, html;

                var stock = selectedSku.Stock != "" ? parseFloat(selectedSku.Stock) : 999;
                var stockMaxValue = selectedSku.StockMaxValue != "" ? parseFloat(selectedSku.StockMaxValue) : 10;
                var quanta = selectedSku.Quanta != "" ? parseFloat(selectedSku.Quanta) : 1;
                var minQuantity = selectedSku.MinQuantity != "" ? parseFloat(selectedSku.MinQuantity) : quanta;
                var maxQuantity = selectedSku.MaxQuantity != "" ? parseFloat(selectedSku.MaxQuantity) : stock;
                maxQuantity = Math.min(maxQuantity, stock);
                var quantity = minQuantity * quanta;
                var selectedValue = quantity;

                //create model
                for (var i = 0; i < stockMaxValue; i++)
                {
                    model[i] = { "Value": quantity, "Selected": quantity == selectedValue }
                    quantity = quantity + quanta;
                } 

                //parse html with new model
                if ($quantitySelector.data('type') == "incremental") {
                    html = Vendd.Handlebars.parse("pdQuantitySelector_B", model);
                } else {
                    html = Vendd.Handlebars.parse("pdQuantitySelector_A", model);
                }

                 //update quantity html
                $quantitySelector.html(html);

                //enable quantity selector
                $quantitySelector.removeClass('disabled');

                //update box attributes
                $wrapper.data('quanta', quanta);
                $wrapper.data('min-quantity', minQuantity);
                $wrapper.data('max-quantity', maxQuantity);
            }
                
        }

        wrapper.loading = function (loading) {
            if (loading) {
                $wrapper.addClass('x-loading');
            } else {
                $wrapper.removeClass('x-loading');
            };
        };

        wrapper.updateSizes();

        wrapper.updateProductInfo();

        wrapper.updateQuantity();

        if (selectedSku && selectedSku.color == "0")
            $colorSelector.hide();

        if (selectedSku && selectedSku.size == "0")
            $sizeSelector.hide();
    });

    function getSKU(skuJson, color,size) {
        return Object.values(skuJson.skus).filter(function (sku) { return sku.color == color && sku.size == size; })[0];
    }

    function getSizes(skuJson, color) {
        var allSizes = (Object.values(skuJson.skus).filter(function (sku) { return sku.color == color }));
        return allSizes.map(function (obj) { return obj.size; });
    }

    function getColors(skuJson, size) {
        var allColors = (Object.values(skuJson.skus).filter(function (sku) { return sku.size == size }));
        return allColors.map(function (obj) { return obj.color; });
    }

    function getImageColor(skuJson, color) {
        if (skuJson.ColorDimensions[color] == undefined) return null;
        if (skuJson.ColorDimensions[color][0] == undefined) return null;
        return skuJson.ColorDimensions[color][0]['List'];
    }

    var currency = decodeEntities(LhApp.Context.Currency.Symbol);

    $('.currency-symbol', $allToCartCont).text(currency);

    $('.js-add-all-to-cart', $allToCartCont).click(function () {

        if ($(this).hasClass('disabled') || $(this).is(':disabled'))
            return;

        var dataArray = [];

        $.each($boxes, function (i, el) {
            var $wrapper = $(this);
            if ($wrapper.hasClass('js-can-add-to-cart')) { 
                var data = {};
            
                var id = $wrapper.data("productid"),
                skuId = $wrapper.data("variantid"),
                path = $wrapper.data("path"),
                qty = $('.x-product-details-quantity-selector .js-selector', $wrapper).val();

                var data = {
                    id: id,
                    skuId: skuId,
                    path: path,
                    qty: qty
                };

                dataArray.push(data);
            }
        });
        Vendd.MessageBus.publishAsync($control.get(0), new Vendd.Cart.Messages.MultipleAdd(dataArray));
        //Open the widget only for template 1 of Cart Widget
        if ($('.x-cart-widget').data('template') === 1) {
            Vendd.MessageBus.publishAsync($wrapper, new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.CartWidget, false));
        }
    });

    $('.js-related-products').removeClass('x-loading');

});
